"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPreviousLocationFlow = void 0;
var tslib_1 = require("tslib");
var takeGaurd_1 = require("../utilities/takeGaurd");
var setPreviousLocationFlow = function () {
    var action, pathname, search;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!1) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, takeGaurd_1.takeGaurd)('LOCATION_CHANGE')];
            case 1:
                action = _a.sent();
                pathname = action.values.pathname;
                search = action.values.queryString;
                if (window.setPreviousLocation && pathname) {
                    window.setPreviousLocation({
                        pathname: pathname,
                        search: search,
                    });
                }
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
exports.setPreviousLocationFlow = setPreviousLocationFlow;
